module.exports = __webpack_public_path__ + "static/divan-ev-1eda7bfe18b58d36bd8c6c7986b17a86.png";